module.exports = __webpack_public_path__ + "img/JE.1478f6ec.svg";